module.exports = __webpack_public_path__ + "static/media/micro_bio_1.b03e717a.JPG";